import React from 'react';
import { ORDEN_ALFABETICO, ORDEN_POR_ETIQUETA } from '../../lib/listas';

/**
 * Buscador y orden para una lista del panel.
 *
 * Lo usan la lista de personal y la de recursos, que son la misma pantalla dos
 * veces: un buscador arriba y un selector de orden al lado. Está acá y no
 * escrito dos veces adentro de Dashboard.jsx por eso mismo.
 *
 * El selector de orden cambia de etiqueta según la lista —"Por rol" para
 * personal, "Por tipo" para recursos— porque son la misma operación sobre datos
 * distintos, y "Por etiqueta" no significa nada para quien lo está mirando.
 *
 * Se esconde solo cuando hay pocos elementos: un buscador arriba de tres
 * personas ocupa más lugar del que ahorra. Aparece cuando empieza a haber algo
 * que buscar.
 */
export default function BuscadorDeLista({
  texto,
  onTexto,
  orden,
  onOrden,
  etiquetaDelOrden,
  total,
  visibles,
  placeholder,
  /** Debajo de esto no se muestra: la lista entera entra en pantalla. */
  desde = 5,
}) {
  if (total < desde) return null;

  return (
    <div className="buscador-de-lista">
      <div className="buscador-campo">
        <span className="buscador-icono" aria-hidden="true">🔍</span>
        <input
          type="search"
          value={texto}
          onChange={(e) => onTexto(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
        />
        {texto && (
          <button
            type="button"
            className="buscador-limpiar"
            onClick={() => onTexto('')}
            aria-label="Limpiar la búsqueda"
          >
            ✕
          </button>
        )}
      </div>

      <label className="buscador-orden">
        <span>Ordenar</span>
        <select value={orden} onChange={(e) => onOrden(e.target.value)}>
          <option value={ORDEN_ALFABETICO}>A – Z</option>
          <option value={ORDEN_POR_ETIQUETA}>{etiquetaDelOrden}</option>
        </select>
      </label>

      {/* Cuántos quedaron. Sin esto, buscar algo que no existe se ve igual que
          una lista vacía por cualquier otro motivo. */}
      {texto && (
        <span className="buscador-resultado">
          {visibles === 0
            ? 'No hay coincidencias'
            : `${visibles} de ${total}`}
        </span>
      )}
    </div>
  );
}
